import { ComponentDataDestService } from '../component-data-dest.service';
import { environment } from '../../../environment/environment';
import { Observable } from 'rxjs';
import { WeekRotationDayMap } from '../../../components/duna/duna-events-group-calendar/group-calendar-settings.interface';

/**
 * Bulk-apply week rotation to group-calendar events in a year (single backend request).
 */
export function apply_group_calendar_week_rotation(
  componentDataDestService: ComponentDataDestService,
  data: {
    year: number;
    weekCount: number;
    anchorDate: string;
    weeks: WeekRotationDayMap[];
  }
): Observable<unknown> {
  const year = Number(data.year);
  const weekCount = Number(data.weekCount);
  const anchorDate = String(data.anchorDate ?? '').slice(0, 10);
  const weeks = Array.isArray(data.weeks) ? data.weeks : [];
  if (
    !Number.isFinite(year) ||
    year < 2000 ||
    weekCount < 1 ||
    !anchorDate ||
    weeks.length === 0
  ) {
    return new Observable((obs) =>
      obs.error(new Error('year, weekCount, anchorDate and weeks are required'))
    );
  }
  return componentDataDestService.http.post(
    `${environment.apiUrl}/events/group-calendar/apply-week-rotation`,
    { year, weekCount, anchorDate, weeks },
    { withCredentials: true }
  );
}
